import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import React from "react";

const TradeRootStringCellRenderer = (params: any) => {
  const fieldName: string = params.fieldName;
  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const value = (fullTradeData as any)?.[fieldName];
  return (
    <div
      data-testid={`${fieldName}CellContainer`}
      id={`${fieldName}CellContainer`}
      className="justify-center text-center"
      style={{ width: "100%" }}
    >
      {value ?? ""}
    </div>
  );
};

export default TradeRootStringCellRenderer;
